import { Card, Col, DatePicker, Flex, Row, Typography } from "antd";
import dayjs, { Dayjs } from "dayjs";
import React, { useMemo } from "react";
import { useState } from "react";
import { SystemStatusChangeBackgroundLegend } from "./SystemStatusChangeBackgroundLegend";
import { MoistureDisplayChart } from "./MoistureDisplayChart";
import { TemperatureDisplayChart } from "./TemperatureDisplayChart";
import { useGetPremierPlusBinTapestripData } from "src/queries/useGetPremierPlusBinTapestripData";
import { useGetPremierPlusBinDto } from "src/queries/useGetPremierPlusBinDto";

interface ChartsProps{
    binId: number | null | undefined;
}

export const Charts : React.FC<ChartsProps> = ({ binId }) => {
    const [dates, setDates] = useState<[Dayjs | null, Dayjs | null]>([null, null]);

    const { getPremierPlusBinDtoQuery } = useGetPremierPlusBinDto(binId ?? 0,{ enabled: true, refetchOnWindowFocus: false });
    const { getPremierPlusTapestripDataQuery } = useGetPremierPlusBinTapestripData(binId ?? 0, dates[0]?.toISOString() ?? null, dates[1]?.toISOString() ?? null, { enabled: true });
    
    return <>
        <Card title={
            <Flex gap="large" align="center" wrap="wrap">
                <Typography.Text>Charts</Typography.Text>
                <DatePicker.RangePicker allowClear
                    onChange={(dates, dateStrings) => {
                        const userTimezone = dayjs.tz.guess();

                        let startOf = null;
                        let endOf = null;
                        if (dates?.[0] != null) {
                            const convertedStart = dayjs.tz(dates[0], userTimezone);
                            startOf = dayjs.tz(convertedStart?.startOf?.('day'));
                        }
                        if (dates?.[1] != null) {
                            const convertedEnd = dayjs.tz(dates[1], userTimezone);
                            endOf = convertedEnd?.endOf?.('day');
                        }

                        setDates([startOf, endOf]);
                    }}
                    showTime={false} />
            </Flex>
        }
            //</>size="small"
            extra={
                <SystemStatusChangeBackgroundLegend />
            }>
            <Row justify={"space-between"} gutter={[24, 32]}>
                <Col md={12} xs={24}>
                    <MoistureDisplayChart binId={getPremierPlusBinDtoQuery.data?.binId ?? 0} tapestrips={getPremierPlusTapestripDataQuery.data ?? []} isLoading={getPremierPlusTapestripDataQuery.isLoading} deviceId={getPremierPlusBinDtoQuery.data?.deviceId ?? ""}/>
                </Col>
                <Col md={12} xs={24}>
                    <TemperatureDisplayChart binId={getPremierPlusBinDtoQuery.data?.binId ?? 0} tapestrips={getPremierPlusTapestripDataQuery.data ?? []} isLoading={getPremierPlusTapestripDataQuery.isLoading} deviceId={getPremierPlusBinDtoQuery.data?.deviceId ?? ""} />
                </Col>
            </Row>
            {/* <MoistureDisplay value={dates} /> */}
        </Card>
    </>;
}